export const TEST_ID = 'footerNavigationLink';
